"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRememberedState = useRememberedState;
exports.useRememberedFlag = useRememberedFlag;
const react_1 = require("react");
/**
 * 記住使用者最後選的分頁、檢視、篩選：從側欄回到這一頁時接著顯示上次的畫面（主流做法，例：Linear、Jira、Asana）
 * - key 帶系統前綴，例：`crm-ui:opportunity.funnel`、`pm-ui:gantt.viewMode`
 * - 存在這台瀏覽器的 localStorage（換帳號時會清掉）；讀寫失敗（無痕、被封鎖）時就用預設值，不影響畫面
 * - 讀到的值不在 allowed 清單裡（改版後選項變了、被手動改過）時用預設值；
 *   選項要等 API 才知道（例：商機階段）時不傳 allowed，由頁面在選項載入後檢查
 * - 不記住：搜尋文字、日期區間、詳情頁分頁
 */
function useRememberedState(key, defaultValue, allowed) {
    const [value, setValue] = (0, react_1.useState)(() => {
        try {
            const saved = localStorage.getItem(key);
            return saved && (!allowed || allowed.includes(saved)) ? saved : defaultValue;
        }
        catch {
            return defaultValue;
        }
    });
    const update = (0, react_1.useCallback)((next) => {
        setValue(next);
        try {
            localStorage.setItem(key, next);
        }
        catch { /* localStorage 不可用時只是不記住 */ }
    }, [key]);
    return [value, update];
}
const FLAG_VALUES = ['on', 'off'];
/** 開／關版本（例：漏斗圖展開、欄位顯示） */
function useRememberedFlag(key, defaultValue) {
    const [value, setValue] = useRememberedState(key, defaultValue ? 'on' : 'off', FLAG_VALUES);
    const update = (0, react_1.useCallback)((next) => setValue(next ? 'on' : 'off'), [setValue]);
    return [value === 'on', update];
}
